<script setup>
import { usePassengerCounter } from './usePassengerCounter';
import PassengersCounter from './PassengersCounter.vue';
import PassengersAgeSelector from './PassengersAgeSelector.vue';

const passengers = defineModel('passengers', {
	required: true,
	type: Object,
	default: () => ({})
});

const emit = defineEmits(['changeView']);

const {
	activeAgeIndex,
	isIncrementDisabled,
	isDecrementDisabled,
	increment,
	decrement,
	removeAge,
	setAge,
	setActiveAgeIndex
} = usePassengerCounter(passengers, 'youth', {
	minCount: 1,
	maxCount: 9
});

const ageOptions = Array.from({ length: 14 }, (_, i) => i + 12);
</script>

<template>
  <div class="abPassengers__view abPassengers__view--youth">
    <div class="abPassengers__group abPassengers__group--changeView">
      <button
        class="abPassengers__item abBtn abBtn abBtn--whiteBlue"
        tabindex="-1"
        @click.stop="emit('changeView')"
      >
        <span class="icon icon-chevron-left" />
        <span class="abPassengers__type">
          {{ $l('searchBox.passengers.adults') }} & {{ $l('searchBox.passengers.children') }}
        </span>
      </button>
    </div>

    <div class="abPassengers__group abPassengers__group--youth">
      <PassengersCounter
        :label="$l('searchBox.passengers.youth')"
        :age-range="`12-25 ${$l('searchBox.passengers.years')}`"
        :count="passengers.youth.count"
        :is-increment-disabled="isIncrementDisabled"
        :is-decrement-disabled="isDecrementDisabled"
        @increment="increment"
        @decrement="decrement"
      />
      <div class="abPassengers__wrapper">
        <div class="abPassengers__msg">
          {{ $l('searchBox.passengers.youthWarning.2') }}
        </div>
      </div>
    </div>

    <PassengersAgeSelector
      type="youth"
      :ages="passengers.youth.ages"
      :active-index="activeAgeIndex"
      :age-options="ageOptions"
      :label="$l('searchBox.passengers.youth')"
      :select-age-prompt="$l('searchBox.passengers.selectYouthsAge')"
      :show-count="passengers.youth.count > 0"
      @remove-age="removeAge"
      @set-active-index="setActiveAgeIndex"
      @set-age="setAge"
    >
      <template #age-display="{ age }">
        <span>{{ age }} {{ $l('searchBox.passengers.yearsOld') }}</span>
      </template>
    </PassengersAgeSelector>
  </div>
</template>
